import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    // 保存API返回的活动信息，及报名情况
    title: '',
    excerpt: '',
    content: '',
    first: true,
    price: 0,
    friend_price: 0,
    child_price: 0,
    friend_count: 0,
    child_count: 0,

    //
    adult: true,            // 是否是成人
    onlyOne: true,          // 是否一个人
}

// mutations
const mutations = {
    event(state, data) {
        state.title = data.title;
        state.excerpt = data.excerpt;
        state.content = data.content;
        state.first = data.first;
        state.price = state.price;
        state.friend_price = state.friend_price;
        state.child_price = state.child_price;
        state.friend_count = state.friend_count;
        state.child_count = state.child_count;
    },
    people(state, {adult, onlyOne}) {
        state.adult = adult;
        state.onlyOne = onlyOne;
    }
}

export default {
    namespaced: true,
    state,
    //    getters,
    //    actions,
    mutations
}